import { Injectable } from '@angular/core';
import { RouterService } from 'app/global/router.service';
import { IframeAbleService } from './iframeable.service';
import { BaseRedirectGuard } from './base-redirect.guard';

@Injectable({ providedIn: 'root' })

export class IframeAbleAuthGuard extends BaseRedirectGuard {
  constructor(
    private iframeAbleService: IframeAbleService,
    _routerService: RouterService
  ) {
    super(_routerService);
  }

  async checkCondition(): Promise<boolean> {
    return await this.iframeAbleService.isIframeAbleLoggedIn();
  }

  getRedirectUrl(): string {
    return '/iframeable/select-template';
  }
}
